export default __webpack_public_path__ + "static/media/icon_subscribers.d266d1f3.svg";